import { QRCODE } from "../action-types";


const getQRCodeList = () => ({
  type: QRCODE.GET_QRCODE_LIST,
});


const setQRCodeList = (qrCodeList) => ({
  type: QRCODE.SET_QRCODE_LIST,
  qrCodeList,
});


export {
      getQRCodeList ,setQRCodeList
};
